const YTPlayer = require('yt-player');

/**
 * Sets up event listeners on YouTube embeds
 * and stops/rewinds the video on modal dismiss
 * and video end. Intended to prevent display
 * of related videos.
 *
 * @todo setup to update all youtube embeds
 *
 * @uses https://www.npmjs.com/package/yt-player
 * @uses https://youtube.com/iframe_api
 * @author LWK
 */
export function setupYouTubeEmbeds() {
	let iframesUpdated = false;

	const fixModalIframes = () => {
		const modals = document.querySelectorAll('.modal-video');
		modals.forEach((modal) => {
			const iframe = modal.querySelector('iframe');
			if (iframe.dataset.src) {
				iframe.setAttribute('src', iframe.dataset.src);
				iframe.dataset.src = null;
			}

			if (-1 == iframe.src.indexOf('youtube')) {
				return;
			}

			// May need to doublecheck this regex but it works with their current videos
			const videoIdMatches = iframe.src.match(
				/\/embed\/([a-zA-Z0-9_-]*)/
			);

			if (videoIdMatches && videoIdMatches[1]) {
				const dest = document.createElement('div');
				dest.classList.add('embed-responsive-item');

				iframe.parentNode.replaceChild(dest, iframe);

				const player = new YTPlayer(dest);
				player.load(videoIdMatches[1]);

				player.on('ended', (e) => {
					player.seek(0);
					player.stop();
				});

				$(modal).on('hidden.bs.modal', () => {
					player.seek(0);
					player.stop();
				});
			}
		});
	};

	const toggles = document.querySelectorAll('[data-toggle="modal"]');
	toggles.forEach((toggle) =>
		toggle.addEventListener('click', (e) => {
			if (!iframesUpdated) {
				fixModalIframes();
				iframesUpdated = true;
			}
		})
	);
}
